module.exports = __webpack_public_path__ + "img/default-apk-icon.b4d0f387.svg";